export const locale = {
    lang: 'en',
    data: {
        MENU: {
            DASHBOARD: 'Panel',
            PROPIETORS: 'Proprietors',
            PROPERTIES: 'Properties',
            UNIT:'Units',
            TENANTS: 'Clients',
            LEASES: 'Rental contract',
            COMPANY_ANNEX: 'Company annexes',
            UTILITIES: 'Utilities',
            INVOICES: 'Facturas',
            PAYMENTS: 'Payments',
            EVICTION_NOTICE: 'Eviction notice',
            NOTIFICATIONS: 'Notifications',
            PRODUCTS: 'Products',
            ORDERS: 'Orders',
            BRANCHES: 'Branches',
            INVENTORIES: 'Inventories',
            PROVIDERS: 'Providers',
            CLIENTS: 'Patients',
            USERS: 'Users',
            ROLES: 'Roles',
            CONFIGURATIONS: 'Configurations',
            PURCHASES: 'Purchases',
            RECEPTIONS: 'Receptions',
            REMISSIONS: 'Remissions',
            EXPENSES: 'Expenses',
            COMPANY_ANNEX_INVOICES: 'Company invoices'
        }
    }
}
